// API Keys
export const SENDGRID_API_KEY = import.meta.env.NEXT_PUBLIC_SENDGRID_API_KEY || "";

// Email Settings
export const EMAIL_FROM = {
  email: "planning@contentgardener.ai",
  name: "ContentGardener.ai",
};

const defaultConfig = {
  supabase: {
    functionsUrl: import.meta.env.VITE_SUPABASE_FUNCTIONS_URL as string,
  },
  frontendApp: {
    mode: import.meta.env.VITE_APP_ENV as string,
  },
};

export default defaultConfig;
